// extracted by mini-css-extract-plugin
export default {"hand":"aboutme_hand__iF-om","wave-animation":"aboutme_wave-animation__RpHGx"};